import React from "react"
import { BooleanField, Datagrid } from "react-admin"
import { OfficeField } from "../offices/OfficeField"
import { MemberTypeField } from "./MemberTypeField"
import { SeasonField } from "../seasons/SeasonField"


export const ParticipantMemberTypeGrid = ({ ...props }) => {
  return <Datagrid size="small" {...props}>
    <SeasonField source="seasonId" />
    <MemberTypeField source="memberTypeId" />
    <OfficeField source="officeId" />
    <BooleanField source="isActive" />
  </Datagrid>
}
